import { Column, Skeleton, SkeletonBox } from "@hightouch/htui";
import { LandingLayout } from "./landing-layout";
import { QuickPromptsGrid } from "./quick-prompts-grid";
import {
  LatestIdeasSection,
  LatestIdeasSkeletonTiles,
} from "./latest-ideas-layout";

// Loading placeholder for the Ad Studio landing (create-a-chat) surface, shown
// as the projects route's Suspense fallback. Mirrors the real layout of
// AdStudioProjects — a centered heading, the elevated chat input, the responsive
// grid of quick-prompt tiles, and the latest ideas strip — through the same
// LandingLayout so nothing shifts when the real content arrives. Kept in its own
// module (not projects/index.tsx) so routes.tsx can import it statically as a
// fallback without pulling the lazy page chunk into the main bundle.

// One key per quick-prompt tile (QuickPrompts renders 5); string keys avoid the
// array-index-key lint rule on this static list.
const TILE_KEYS = ["a", "b", "c", "d", "e"];

export function AdStudioLandingSkeleton(): JSX.Element {
  return (
    <LandingLayout
      footer={
        <LatestIdeasSection>
          <LatestIdeasSkeletonTiles />
        </LatestIdeasSection>
      }
    >
      <Skeleton isLoading>
        <SkeletonBox
          height="32px"
          width="440px"
          maxWidth="90%"
          borderRadius="md"
        />
      </Skeleton>
      <Column width="100%" maxWidth="640px" gap={6}>
        <Skeleton isLoading>
          <SkeletonBox height="120px" width="100%" borderRadius="2xl" />
        </Skeleton>
        <QuickPromptsGrid>
          {TILE_KEYS.map((key) => (
            <Skeleton key={key} isLoading>
              <SkeletonBox width="100%" height="100px" borderRadius="2xl" />
            </Skeleton>
          ))}
        </QuickPromptsGrid>
      </Column>
    </LandingLayout>
  );
}
